import React from "react";
import Slider, {type Settings} from "react-slick";
import hoistNonReactStatics from "hoist-non-react-statics";

export interface IProps extends Settings {
    afterChange?: (idx: number) => void;
    children?: React.ReactNode;
    className?: string;
    // eslint-disable-next-line
    ref?: any;
}

export type SliderType = Slider | null;

// eslint-disable-next-line
const SlickSliderC: React.FC<IProps> = React.forwardRef((props: IProps, ref: any) => {
    return (
        <Slider {...props} ref={ref}>
            {props.children}
        </Slider>
    );
});

export const SlickSlider = hoistNonReactStatics(SlickSliderC, Slider);
import React from "react";
import Slider, {type Settings} from "react-slick";
import hoistNonReactStatics from "hoist-non-react-statics";

export interface IProps extends Settings {
    afterChange?: (idx: number) => void;
    children?: React.ReactNode;
    className?: string;
    // eslint-disable-next-line
    ref?: any;
}

export type SliderType = Slider | null;

// eslint-disable-next-line
const SlickSliderC: React.FC<IProps> = React.forwardRef((props: IProps, ref: any) => {
    return (
        <Slider {...props} ref={ref}>
            {props.children}
        </Slider>
    );
});

export const SlickSlider = hoistNonReactStatics(SlickSliderC, Slider);
